import React from 'react';

import { flagStyles } from '../settings';

const SvgID = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2376px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgID;
